// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class TransactionStatisticsTMO {
	public finished?: TransactionStatisticsType = new TransactionStatisticsType();
	public started?: TransactionStatisticsType = new TransactionStatisticsType();
	public updated?: TransactionStatisticsType = new TransactionStatisticsType();
}

export class TransactionStatisticsTypeTMO {
	public error?: TransactionStatisticsTypeDetail = new TransactionStatisticsTypeDetail();
	public info?: TransactionStatisticsTypeDetail = new TransactionStatisticsTypeDetail();
	public warn?: TransactionStatisticsTypeDetail = new TransactionStatisticsTypeDetail();
}

export class TransactionStatisticsTypeDetailTMO {
	public count?: number = undefined;
	public operations?: TransactionOperationCount[] = [];
}

export class TransactionOperationCountTMO {
	public key?: string = undefined;
	public count?: number = undefined;
}

export class TenantTransactionStatisticsTMO extends TransactionStatisticsTMO {
	public date?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)

export class TransactionStatistics extends TransactionStatisticsTMO {}

export class TransactionStatisticsType extends TransactionStatisticsTypeTMO {}

export class TransactionStatisticsTypeDetail extends TransactionStatisticsTypeDetailTMO {}

export class TransactionOperationCount extends TransactionOperationCountTMO {}

export class TenantTransactionStatistics extends TenantTransactionStatisticsTMO {
	public id?: string = undefined; // unique identifier is the statistics date
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************

// ENUMS #############################################################
// API enums *********************************************************
// UI enums *********************************************************
